import React from 'react';
import { theme } from '../theme';
import { pillFace, pillStyle } from './SecondaryAxisPills';
import { InfoTooltip } from './InfoTooltip';

// Neutral GELB review-tier chip — same visual class as ZoneChip's Gelb variant (fg/bg/border
// tokens, pill shape) but for flagging content that needs a human look independent of the D3
// hand-off zone (e.g. a generative-answer segment). theme.colors.warning is the K4-exclusive
// orange and must NEVER be used here — this chip is keyed to theme.colors.zone.gelb instead.
// `hover` (fix wave M4, renamed from `title`): the explanation rides the shared InfoTooltip, not
// a native title= attribute, so the prop no longer names an HTML attribute this chip does not
// emit. Omitted ⇒ the bare chip, with no tooltip and no focus stop.
//
// Pill house rule shape-borrower, same posture as ZoneChip just above — EXCEPT the label here is
// free prose each call site composes, not a fixed doctrine word, so unlike Stufe/Zone this face
// DOES route through `pillFace('info', …)` (chip register sweep, Part C wave 2, 2026-09-09).
export const ReviewChip: React.FC<{ label: string; hover?: string; style?: React.CSSProperties }> = ({ label, hover, style }) => {
  const z = theme.colors.zone.gelb;
  const chip = (
    <span style={{
      ...pillStyle('info', 'row'),
      fontWeight: 700, letterSpacing: 0.4,
      color: z.fg, backgroundColor: z.bg, border: `1px solid ${z.border}`,
      display: 'inline-block',
      ...style,
    }}>
      {pillFace('info', label)}
    </span>
  );
  return hover ? <InfoTooltip text={hover}>{chip}</InfoTooltip> : chip;
};
